import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { ErrorMessage, Field } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import React from 'react';
import { validateIssueKey } from "./IssueKeyInput.utils";

const IssueKeyContainer = _styled("div", {
  target: "e1d7t3r10",
  label: "IssueKeyContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "133oqug",
  styles: "max-width:25%;"
} : {
  name: "133oqug",
  styles: "max-width:25%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9NYW5hZ2VQYXJ0bmVycy9QYXJ0bmVyQWRtaW4vY29tcG9uZW50cy9Jc3N1ZUtleUlucHV0L0lzc3VlS2V5SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU29DIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9NYW5hZ2VQYXJ0bmVycy9QYXJ0bmVyQWRtaW4vY29tcG9uZW50cy9Jc3N1ZUtleUlucHV0L0lzc3VlS2V5SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5pbXBvcnQgeyBFcnJvck1lc3NhZ2UsIEZpZWxkIH0gZnJvbSAnQGF0bGFza2l0L2Zvcm0nO1xuaW1wb3J0IFRleHRmaWVsZCBmcm9tICdAYXRsYXNraXQvdGV4dGZpZWxkJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IHZhbGlkYXRlSXNzdWVLZXkgfSBmcm9tICcuL0lzc3VlS2V5SW5wdXQudXRpbHMnO1xuXG5jb25zdCBJc3N1ZUtleUNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIG1heC13aWR0aDogMjUlO1xuYDtcblxudHlwZSBQcm9wcyA9IHt8XG4gIGlzc3VlS2V5OiBzdHJpbmcsXG58fTtcblxuY29uc3QgSXNzdWVLZXlJbnB1dCA9ICh7IGlzc3VlS2V5IH06IFByb3BzKSA9PiAoXG4gIDxJc3N1ZUtleUNvbnRhaW5lcj5cbiAgICA8RmllbGRcbiAgICAgIG5hbWU9XCJzZWN1cml0eUlzc3VlS2V5XCJcbiAgICAgIGxhYmVsPVwiSXNzdWUga2V5XCJcbiAgICAgIGRlZmF1bHRWYWx1ZT17aXNzdWVLZXl9XG4gICAgICB2YWxpZGF0ZT17dmFsaWRhdGVJc3N1ZUtleX1cbiAgICAgIGlzUmVxdWlyZWRcbiAgICA+XG4gICAgICB7KHsgZmllbGRQcm9wcywgZXJyb3IgfSkgPT4gKFxuICAgICAgICA8PlxuICAgICAgICAgIDxUZXh0ZmllbGQgey4uLmZpZWxkUHJvcHN9IC8+XG4gICAgICAgICAge2Vycm9yID8gPEVycm9yTWVzc2FnZT57ZXJyb3J9PC9FcnJvck1lc3NhZ2U+IDogbnVsbH1cbiAgICAgICAgPC8+XG4gICAgICApfVxuICAgIDwvRmllbGQ+XG4gIDwvSXNzdWVLZXlDb250YWluZXI+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBJc3N1ZUtleUlucHV0O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const IssueKeyInput = ({
  issueKey
}) => /*#__PURE__*/React.createElement(IssueKeyContainer, null, /*#__PURE__*/React.createElement(Field, {
  name: "securityIssueKey",
  label: "Issue key",
  defaultValue: issueKey,
  validate: validateIssueKey,
  isRequired: true
}, ({
  fieldProps,
  error
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Textfield, fieldProps), error ? /*#__PURE__*/React.createElement(ErrorMessage, null, error) : null)));

export default IssueKeyInput;